// apps/menu/src/translations/allergyTranslations.ts

export const ALLERGY_TRANSLATIONS = {
  en: {
    'celery': 'Celery',
    'corn': 'Corn',
    'crustaceans': 'Crustaceans',
    'eggs': 'Eggs',
    'fish': 'Fish',
    'gluten': 'Gluten',
    'lupin': 'Lupin',
    'milk': 'Milk',
    'dairy': 'Dairy',
    'mollusc': 'Mollusc',
    'molluscs': 'Molluscs',
    'mustard': 'Mustard',
    'nuts': 'Nuts',
    'tree nuts': 'Tree Nuts',
    'peanuts': 'Peanuts',
    'propolis': 'Propolis',
    'sesame': 'Sesame',
    'seseme': 'Sesame',
    'soya': 'Soya',
    'soy': 'Soy',
    'sulphites': 'Sulphites',
    'sulfites': 'Sulfites',
    'wheat': 'Wheat',
    'shellfish': 'Shellfish'
  },
  es: {
    'celery': 'Apio',
    'corn': 'Maíz',
    'crustaceans': 'Crustáceos',
    'eggs': 'Huevos',
    'fish': 'Pescado',
    'gluten': 'Gluten',
    'lupin': 'Altramuz',
    'milk': 'Leche',
    'dairy': 'Lácteos',
    'mollusc': 'Molusco',
    'molluscs': 'Moluscos',
    'mustard': 'Mostaza',
    'nuts': 'Frutos Secos',
    'tree nuts': 'Frutos Secos del Árbol',
    'peanuts': 'Cacahuetes',
    'propolis': 'Propóleo',
    'sesame': 'Sésamo',
    'seseme': 'Sésamo',
    'soya': 'Soja',
    'soy': 'Soja',
    'sulphites': 'Sulfitos',
    'sulfites': 'Sulfitos',
    'wheat': 'Trigo',
    'shellfish': 'Mariscos'
  },
  de: {
    'celery': 'Sellerie',
    'corn': 'Mais',
    'crustaceans': 'Krebstiere',
    'eggs': 'Eier',
    'fish': 'Fisch',
    'gluten': 'Gluten',
    'lupin': 'Lupine',
    'milk': 'Milch',
    'dairy': 'Milchprodukte',
    'mollusc': 'Weichtier',
    'molluscs': 'Weichtiere',
    'mustard': 'Senf',
    'nuts': 'Nüsse',
    'tree nuts': 'Baumnüsse',
    'peanuts': 'Erdnüsse',
    'propolis': 'Propolis',
    'sesame': 'Sesam',
    'seseme': 'Sesam',
    'soya': 'Soja',
    'soy': 'Soja',
    'sulphites': 'Sulfite',
    'sulfites': 'Sulfite',
    'wheat': 'Weizen',
    'shellfish': 'Schalentiere'
  },
  nl: {
    'celery': 'Selderij',
    'corn': 'Maïs',
    'crustaceans': 'Schaaldieren',
    'eggs': 'Eieren',
    'fish': 'Vis',
    'gluten': 'Gluten',
    'lupin': 'Lupine',
    'milk': 'Melk',
    'dairy': 'Zuivel',
    'mollusc': 'Weekdier',
    'molluscs': 'Weekdieren',
    'mustard': 'Mosterd',
    'nuts': 'Noten',
    'tree nuts': 'Boomnoten',
    'peanuts': 'Pinda\'s',
    'propolis': 'Propolis',
    'sesame': 'Sesam',
    'seseme': 'Sesam',
    'soya': 'Soja',
    'soy': 'Soja',
    'sulphites': 'Sulfieten',
    'sulfites': 'Sulfieten',
    'wheat': 'Tarwe',
    'shellfish': 'Schaaldieren'
  },
  fr: {
    'celery': 'Céleri',
    'corn': 'Maïs',
    'crustaceans': 'Crustacés',
    'eggs': 'Œufs',
    'fish': 'Poisson',
    'gluten': 'Gluten',
    'lupin': 'Lupin',
    'milk': 'Lait',
    'dairy': 'Produits Laitiers',
    'mollusc': 'Mollusque',
    'molluscs': 'Mollusques',
    'mustard': 'Moutarde',
    'nuts': 'Noix',
    'tree nuts': 'Noix d\'Arbre',
    'peanuts': 'Arachides',
    'propolis': 'Propolis',
    'sesame': 'Sésame',
    'seseme': 'Sésame',
    'soya': 'Soja',
    'soy': 'Soja',
    'sulphites': 'Sulfites',
    'sulfites': 'Sulfites',
    'wheat': 'Blé',
    'shellfish': 'Fruits de Mer'
  },
  it: {
    'celery': 'Sedano',
    'corn': 'Mais',
    'crustaceans': 'Crostacei',
    'eggs': 'Uova',
    'fish': 'Pesce',
    'gluten': 'Glutine',
    'lupin': 'Lupino',
    'milk': 'Latte',
    'dairy': 'Latticini',
    'mollusc': 'Mollusco',
    'molluscs': 'Molluschi',
    'mustard': 'Senape',
    'nuts': 'Noci',
    'tree nuts': 'Frutta a Guscio',
    'peanuts': 'Arachidi',
    'propolis': 'Propoli',
    'sesame': 'Sesamo',
    'seseme': 'Sesamo',
    'soya': 'Soia',
    'soy': 'Soia',
    'sulphites': 'Solfiti',
    'sulfites': 'Solfiti',
    'wheat': 'Grano',
    'shellfish': 'Frutti di Mare'
  },
  pt: {
    'celery': 'Aipo',
    'corn': 'Milho',
    'crustaceans': 'Crustáceos',
    'eggs': 'Ovos',
    'fish': 'Peixe',
    'gluten': 'Glúten',
    'lupin': 'Tremoço',
    'milk': 'Leite',
    'dairy': 'Laticínios',
    'mollusc': 'Molusco',
    'molluscs': 'Moluscos',
    'mustard': 'Mostarda',
    'nuts': 'Nozes',
    'tree nuts': 'Frutos Secos',
    'peanuts': 'Amendoins',
    'propolis': 'Própolis',
    'sesame': 'Gergelim',
    'seseme': 'Gergelim',
    'soya': 'Soja',
    'soy': 'Soja',
    'sulphites': 'Sulfitos',
    'sulfites': 'Sulfitos',
    'wheat': 'Trigo',
    'shellfish': 'Frutos do Mar'
  }
};